"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.SearchInput = void 0;
const styled_1 = __importDefault(require("@emotion/styled"));
const ui_theme_1 = require("@kyruus/ui-theme");
const styles_1 = require("../../../styles");
exports.SearchInput = (0, styled_1.default)('input') `
  ${styles_1.baseStyle}
  font-size: ${(0, ui_theme_1.fromTheme)('font_size')};
  color: ${(0, ui_theme_1.fromTheme)('color_text')};
  padding: ${(0, ui_theme_1.fromTheme)('spacing_small')} ${(0, ui_theme_1.fromTheme)('spacing_medium')};
  border-radius: unset;
  width: auto;
  border: ${styles_1.borderStyle};
  text-overflow: ellipsis;
`;
//# sourceMappingURL=GlobalSearch.styles.js.map